var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 528,
    height: 528,
    viewBox: "0 0 528 528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 28,
    d: "M348.95288,250 C348.95288,304.652042 304.649843,348.95288 250,348.95288 C195.350157,348.95288 151.04712,304.649843 151.04712,250 C151.04712,195.350157 195.350157,151.04712 250,151.04712 C304.649843,151.04712 348.95288,195.350157 348.95288,250"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 28,
    d: "M286.649215,37.434555 L213.350785,37.434555",
    transform: "rotate(90 250 37.435)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 28,
    d: "M286.649215,462.565445 L213.350785,462.565445",
    transform: "rotate(90 250 462.565)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 28,
    d: "M499.21466,250 L425.91623,250",
    transform: "rotate(180 462.565 250)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 28,
    d: "M74.0837696,250 L0.785340314,250",
    transform: "rotate(180 37.435 250)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 28,
    d: "M441.242849,95.4014413 L367.945115,95.4014413",
    transform: "rotate(135 404.594 95.401)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 28,
    d: "M132.054367,404.594234 L58.7566331,404.594234",
    transform: "rotate(135 95.405 404.594)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 28,
    d: "M441.242849,404.593716 L367.945115,404.593716",
    transform: "rotate(-135 404.594 404.594)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 28,
    d: "M132.054367,95.405766 L58.7566331,95.405766",
    transform: "rotate(-135 95.405 95.406)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.85035c888a910419ca5143d3bb2e84d4.svg";
export { ForwardRef as ReactComponent };